import React from 'react';
import type { LuggageType } from 'src/components/Luggage/types';
import styled, { css } from 'styled-components';
import FlightsWeightLabel from './FlightsWeightLabel';
import { getIcon } from './utils';

interface FlightsLuggageIconProps {
  weight?: number;
  count?: number;
  type: LuggageType;
  isLabelInside?: boolean;
}

const FlightsLuggageIconWithLabel = ({
  weight,
  count,
  type,
  isLabelInside = false,
}: FlightsLuggageIconProps) => {
  const baggageUnknown = count === undefined;
  const noBaggage = count === 0;
  const weightUnknown = Boolean(count) && !weight;

  return (
    <IconContainer $baggageUnknown={baggageUnknown} $noBaggage={noBaggage}>
      {getIcon({ type, weightUnknown, noBaggage, baggageUnknown })}
      {!baggageUnknown && !weightUnknown && !(isLabelInside && noBaggage) && (
        <FlightsWeightLabel
          isLabelInside={isLabelInside}
          weight={weight}
          noBaggage={noBaggage}
        />
      )}
    </IconContainer>
  );
};

const IconContainer = styled.div<{
  $baggageUnknown: boolean;
  $noBaggage: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 2px;

  > svg {
    height: 20px;

    > path {
      ${({ $baggageUnknown, $noBaggage }) =>
        ($baggageUnknown || $noBaggage) &&
        css`
          fill: var(--grey2);
        `};
    }
  }
`;

export default FlightsLuggageIconWithLabel;
